import { GraphResolverBase } from './GraphResolverBase';
import { ComponentFactory, ViewContainerRef } from '@angular/core';
import { ConfigDataService } from '../services/config-data.service';
import { GraphDataService } from '../services/graph-data-service.service';
import { ViewPeriodService } from '../services/view-period.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { PopoverController } from '@ionic/angular';
import { GenericBarChartData } from '../objects/chart';
import { CHART_PRIMARY_COLOR, CHART_SECONDARY_COLOR } from '../configs/color';
import { DynamicBarChartWrapperComponent } from '../shared-components/dynamic/dynamic-bar-chart-wrapper/dynamic-bar-chart-wrapper.component';
import { DynamicGraphAdditionalInput } from '../objects/config';
import { isScreenSmallerThanMD } from '../helpers/util';

export class AsianEthnicityProfileResolver extends GraphResolverBase {

    public async createComponent(
        componentFactory: ComponentFactory<unknown>,
        _additionalInput: string | DynamicGraphAdditionalInput | undefined,
        configDataService: ConfigDataService,
        graphDataService: GraphDataService,
        _popoverController: PopoverController,
        _viewPeriodService: ViewPeriodService,
        viewContainerRef: ViewContainerRef,
        subscription: Subscription
    ) {
        // load data here
        graphDataService.baseGraphData.addDependency(this.dataDependency);
        await configDataService.loadAppConfig();

        const asianPosInArray: number = configDataService.ETHNICITY_CLASS.findIndex(ethnicity => ethnicity === 'asian');
        const chartLabel = [configDataService.DISPLAY_LANGUAGE.ETHNICITY_CLASS.asian, configDataService.DISPLAY_LANGUAGE.NON_ASIAN_ETHNICITY_CLASS];
        const dualBarData$ = new BehaviorSubject<GenericBarChartData[]>([{
            data: [graphDataService.ethnicityProfileData$.value.female[asianPosInArray],
                graphDataService.ethnicityProfileData$.value.female
                .filter((ethnicity, idx) => idx !== asianPosInArray)
                .reduce((total, val) => total + val, 0)
            ],
            color: CHART_SECONDARY_COLOR,
            label: configDataService.DISPLAY_LANGUAGE.GENDER_CLASS.female,
            calPercentFrommAllData: true
        }, {
            data: [graphDataService.ethnicityProfileData$.value.male[asianPosInArray],
                graphDataService.ethnicityProfileData$.value.male
                .filter((ethnicity, idx) => idx !== asianPosInArray)
                .reduce((total, val) => total + val, 0)
            ],
            color: CHART_PRIMARY_COLOR,
            label: configDataService.DISPLAY_LANGUAGE.GENDER_CLASS.male,
            calPercentFrommAllData: true
        }]);
        subscription.add(graphDataService.ethnicityProfileData$.subscribe(ethnicityData => {
            dualBarData$.next([{
                data: [ethnicityData.female[asianPosInArray],
                    ethnicityData.female.filter((ethnicity, idx) => idx !== asianPosInArray).reduce((total, val) => total + val, 0)
                ],
                color: CHART_SECONDARY_COLOR,
                label: configDataService.DISPLAY_LANGUAGE.GENDER_CLASS.female,
                calPercentFrommAllData: true
            }, {
                data: [ethnicityData.male[asianPosInArray],
                    ethnicityData.male.filter((ethnicity, idx) => idx !== asianPosInArray).reduce((total, val) => total + val, 0)
                ],
                color: CHART_PRIMARY_COLOR,
                label: configDataService.DISPLAY_LANGUAGE.GENDER_CLASS.male,
                calPercentFrommAllData: true
            }]);
        }));

        const componentRef = viewContainerRef.createComponent(componentFactory);
        const comInstance = componentRef.instance as DynamicBarChartWrapperComponent;
        comInstance.title = configDataService.DISPLAY_LANGUAGE.ASIAN_ETHNICITY_PROFILE;
        comInstance.isLock = this.isLock;
        comInstance.isShowLegend = false;
        comInstance.data$ = dualBarData$;
        comInstance.chartLabel = chartLabel;
        comInstance.displayGrid = false;
        comInstance.displayAxis = 'X';
        comInstance.aspectRatio = isScreenSmallerThanMD(window) ? 1.1 : 1.4;
        return comInstance;
    }

}
